import {DoCheck, EventEmitter, Injectable, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {BaseComponent} from "./BaseComponent";

@Injectable()
export abstract class BaseDetailComponent extends BaseComponent implements OnChanges {

  @Input('selectedRow') selectedRow?: any;
  @Input('editMode') editMode?: boolean;

  @Output() close = new EventEmitter();
  @Output() validForm = new EventEmitter<boolean>();



  dataDetail?: any;
  selectedFile?: File;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedRow && !!this.selectedRow) {
      this.resetImage();
      this.dataDetail = JSON.parse(JSON.stringify(this.selectedRow));
    }
    else if (changes.editMode && !!this.selectedRow) {
      if (!this.editMode) {
        this.resetImage();
        this.dataDetail = JSON.parse(JSON.stringify(this.selectedRow));
      }
    }
  }

  onFileSelected(fileEvent: any) {
    this.selectedFile = fileEvent.target.files[0];
  }

  imageFileNameFromUrl(imageUrl: string) {
    const splitted = imageUrl.split('/');
    return splitted[splitted.length - 1];
  }

  resetImage() {
    this.selectedFile = undefined;
  }

}
